<div [formGroup]="form" fxLayout>
  <mat-form-field appearance="outline" fxFlex>
    <mat-select
      [required]="required"
      [placeholder]="placeholder"
      formControlName="fullTime">
      @for (hour of timeArray; track hour) {
        <mat-option [value]="hour"> {{ hour.name }}{{ hour.type }} </mat-option>
      }
    </mat-select>
    <mat-error [for]="['fullTime']"></mat-error>
    @if (hint) {
      <mat-hint align="end">{{ hint }}</mat-hint>
    }
  </mat-form-field>
</div>
